import { StateStorage } from 'zustand/middleware';
import EncryptStorage from './encrypt-storage/index';

export const SECRET_KEY = 'navi-secret-key';

// get stoarge encrypt
export const encrypted = new EncryptStorage(SECRET_KEY);

// Custom storage for support encrypt in zustand
export const encryptStorage: StateStorage = {
  getItem: (name) => encrypted.getItem(name),
  setItem: (name, value) => encrypted.setItem(name, value),
  removeItem: (name) => encrypted.removeItem(name),
};
